import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Table, Pagination, Badge } from 'react-bootstrap';
import API from '../../api';

function ActivityLogs() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ total: 0, pages: 0, current_page: 1, limit: 10 });
    const [logFilters, setLogFilters] = useState({ username: '', action: '', item_type: '', from_date: '', to_date: '' });

    useEffect(() => {
        fetchLogs();
    }, [pagination.current_page]); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchLogs = () => {
        setLoading(true);
        let url = `${API.ACTIVITY_LOGS}?page=${pagination.current_page}&limit=${pagination.limit}`;
        Object.keys(logFilters).forEach(key => {
            if (logFilters[key]) url += `&${key}=${encodeURIComponent(logFilters[key])}`;
        });

        fetch(url, { method: 'GET', credentials: 'include' })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') { setLogs(data.logs); setPagination(data.pagination); }
            setLoading(false);
        })
        .catch(error => { console.error('Error fetching logs:', error); setLoading(false); });
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setPagination(prev => ({ ...prev, current_page: 1 }));
        fetchLogs();
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setLogFilters(prev => ({ ...prev, [name]: value }));
    };

    const handlePageChange = (page) => setPagination(prev => ({ ...prev, current_page: page }));
    const formatDate = (dateString) => new Date(dateString).toLocaleString();

    const getActionColor = (action) => {
        switch(action.toLowerCase()) {
            case 'delete': return 'danger';
            case 'create': return 'success';
            case 'update': return 'warning';
            default: return 'info';
        }
    };

    const getItemTypeIcon = (itemType) => {
        switch(itemType.toLowerCase()) {
            case 'project': return '📁';
            case 'exploit': return '🛠️';
            case 'challenge': return '🏆';
            default: return '📄';
        }
    };

    return (
        <Row>
            <Col md={12}>
                <Card className="admin-panel-card mb-4">
                    <Card.Header className="admin-panel-card-header">Log Filters</Card.Header>
                    <Card.Body>
                        <Form onSubmit={handleFilterSubmit}>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="admin-panel-form-label">Username</Form.Label>
                                        <Form.Control type="text" name="username" value={logFilters.username} onChange={handleFilterChange} placeholder="Filter by username" className="admin-panel-input" />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="admin-panel-form-label">Action</Form.Label>
                                        <Form.Select name="action" value={logFilters.action} onChange={handleFilterChange} className="admin-panel-select">
                                            <option value="">All Actions</option>
                                            <option value="create">Create</option>
                                            <option value="update">Update</option>
                                            <option value="delete">Delete</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label className="admin-panel-form-label">Item Type</Form.Label>
                                        <Form.Select name="item_type" value={logFilters.item_type} onChange={handleFilterChange} className="admin-panel-select">
                                            <option value="">All Types</option>
                                            <option value="project">Project</option>
                                            <option value="exploit">Exploit</option>
                                            <option value="challenge">Challenge</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Button variant="primary" type="submit" className="mt-4 w-100 admin-panel-button">Apply Filters</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="admin-panel-form-label">From Date</Form.Label>
                                        <Form.Control type="date" name="from_date" value={logFilters.from_date} onChange={handleFilterChange} className="admin-panel-input" />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="admin-panel-form-label">To Date</Form.Label>
                                        <Form.Control type="date" name="to_date" value={logFilters.to_date} onChange={handleFilterChange} className="admin-panel-input" />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>

                {loading ? (
                    <div className="loading-spinner"></div>
                ) : (
                    <>
                        <div className="table-responsive admin-panel-logs-container">
                            <Table bordered hover className="admin-panel-logs-table">
                                <thead>
                                    <tr>
                                        <th>ID</th><th>Timestamp</th><th>Username</th><th>Action</th>
                                        <th>Item Type</th><th>Item Name</th><th>Details</th><th>IP Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logs.length > 0 ? logs.map(log => (
                                        <tr key={log.id}>
                                            <td>{log.id}</td>
                                            <td>{formatDate(log.timestamp)}</td>
                                            <td><strong>{log.username}</strong></td>
                                            <td><Badge bg={getActionColor(log.action)}>{log.action.toUpperCase()}</Badge></td>
                                            <td><span>{getItemTypeIcon(log.item_type)} {log.item_type}</span></td>
                                            <td>{log.item_name}</td>
                                            <td>{log.details}</td>
                                            <td>{log.ip_address}</td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="8" className="text-center">No logs found</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>

                        {pagination.pages > 1 && (
                            <div className="d-flex justify-content-center mt-4">
                                <Pagination className="admin-panel-pagination">
                                    <Pagination.First onClick={() => handlePageChange(1)} disabled={pagination.current_page === 1} />
                                    <Pagination.Prev onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1} />
                                    {[...Array(pagination.pages)].map((_, i) => {
                                        if (i === 0 || i === pagination.pages - 1 || (i >= pagination.current_page - 2 && i <= pagination.current_page + 2)) {
                                            return <Pagination.Item key={i + 1} active={i + 1 === pagination.current_page} onClick={() => handlePageChange(i + 1)}>{i + 1}</Pagination.Item>;
                                        } else if (i === pagination.current_page - 3 || i === pagination.current_page + 3) {
                                            return <Pagination.Ellipsis key={i} />;
                                        }
                                        return null;
                                    })}
                                    <Pagination.Next onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.pages} />
                                    <Pagination.Last onClick={() => handlePageChange(pagination.pages)} disabled={pagination.current_page === pagination.pages} />
                                </Pagination>
                            </div>
                        )}

                        <div className="text-center mt-3 admin-panel-logs-stats">
                            <small>Showing {logs.length} of {pagination.total} logs | Page {pagination.current_page} of {pagination.pages || 1}</small>
                        </div>
                    </>
                )}
            </Col>
        </Row>
    );
}

export default ActivityLogs;
